import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        bdoRed: '#eb102f',
        bdoBlack: '#333333',
        orangeMain: '#EE7202',
        btnGray: '#e5ecf0',
        tableGray: '#84A0AF',
        primary: '#999999',
        background1: '#4D535A',
        background2: '#A5A5A8',
        background3: '#E2E0DA',
        background4: '#EEEEEE',
        background5: '#f9f9f9',
        background6: '#f5f5f5',
        textColor: '#3A3A3A',
        headColor: '#8AA3B9',
        success: '#02D00A',
        info: '#029FD0',
        warning: '#D0C802',
        error: '#D0021B'
      }
    }
  },
  lang: {
    locales: { en },
    current: 'en'
  },
  icons: {
    iconfont: 'mdi'
  }
})
